import { Text, View } from '@react-pdf/renderer';

import { styles } from '../style';

interface Props {
  homeinspectionNegotiationDays?: number;
}

const PoolInspection = ({ homeinspectionNegotiationDays }: Props) => {
  return (
    <View>
      <Text style={styles.title}>Pool Inspection Contingency Clause</Text>
      <Text style={styles.text}>
        This contract is contingent upon the Buyer obtaining, at their own
        expense, a professional Pool inspection of the Property within{' '}
        {homeinspectionNegotiationDays} days from the date of contract
        execution. The inspection shall assess the condition and functionality
        of the property's Pool system.
      </Text>
      <Text style={styles.text}>
        Should the inspection reveal any material defects, obstructions, or
        deficiencies in the Pool system, the Buyer shall have the right to:
      </Text>
      <View style={styles.list}>
        <Text style={styles.listItem}>
          a) <Text style={styles.bold}>Request Repairs or Remedies:</Text>{' '}
          Notify the Seller, in writing, within the inspection period of{' '}
          {homeinspectionNegotiationDays} days after the execution date,
          detailing the specific repairs or remedies required. The Seller shall
          respond and agree to the requested repairs or provide an alternative
          resolution acceptable to the Buyer within the inspection period.
        </Text>
        <Text style={styles.listItem}>
          b) <Text style={styles.bold}>Terminate the Contract:</Text> If the
          Seller fails to agree to or complete the requested repairs or if an
          acceptable resolution is not reached within the specified or agreed to
          time frame, the Buyer may, at their sole discretion, terminate this
          contract by providing written notice to the Seller. Upon such
          termination, all deposits made by the Buyer shall be promptly refunded
          in full, and neither party shall have any further obligations under
          this contract.
        </Text>
      </View>
      <Text style={styles.text}>
        Access to the Property for the purpose of conducting the Pool inspection
        shall be provided by the Seller with reasonable notice to the Seller's
        Agent. If the Buyer chooses to conduct additional home inspections
        beyond the Pool inspection, those shall also be conducted at the Buyer's
        expense, with similar access provisions.
      </Text>
      <Text>
        This contingency shall be deemed satisfied or waived if the Buyer does
        not deliver written notice to the Seller regarding the inspection
        results and any required actions within the specified time frames.
      </Text>
    </View>
  );
};

export default PoolInspection;
